import {http} from '@/http'

const resource = "/api/auth";
const userResource = "/api/user";

export default {
    get() {
        return http.get(`${resource}`);
    },
    getUser(userId) {
        return http.get(`${resource}/${userId}`);
    },
    createUser(payload) {
        return http.post(`${resource}`, payload);
    },
    registerUser(payload) {
        return http.post(`${resource}/register/`, payload)
    },
    changePasswordRequest(email) {
        return http.post(`${resource}/ForgetPassword/`, { email: email })
    },
    changePassword(payload) {
        return http.post(`${resource}/ResetPassword/`, payload)
    },
    changeUserPassword(payload) {
        return http.post(`${userResource}/changepassword/`, payload)
    },
    sendConfirmationEmail(email) {
        return http.post(`${resource}/sendConfirmationEmail/`, { email: email })
    },
}
